import { pluralizeUk } from './pluralize'

/** Мінімальна довжина нового пароля (бекенд перевіряє те саме: ChangePasswordController::MIN_LENGTH) */
export const PASSWORD_MIN_LENGTH = 4

/** «4 символи» — для підказок «Мінімум …» */
export const PASSWORD_MIN_LENGTH_LABEL = `${PASSWORD_MIN_LENGTH} ${pluralizeUk(PASSWORD_MIN_LENGTH, ['символ', 'символи', 'символів'])}`

export interface PasswordCheck {
    /** Довжина не менша за PASSWORD_MIN_LENGTH */
    lengthOk: boolean
    /** Підтвердження збігається з паролем (лише коли обидва введені) */
    matchOk: boolean
    /** Підтвердження введене і не збігається: показуємо як помилку */
    mismatch: boolean
    /** Можна відправляти */
    canSubmit: boolean
}

export const checkPassword = (password: string, confirmation: string): PasswordCheck => {
    const lengthOk = password.length >= PASSWORD_MIN_LENGTH
    const matchOk = password.length > 0 && confirmation.length > 0 && password === confirmation
    const mismatch = confirmation.length > 0 && password !== confirmation
    return { lengthOk, matchOk, mismatch, canSubmit: lengthOk && matchOk }
}
